import React from 'react'
import './custom-datepicker.css'
import DatePicker, { registerLocale } from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import { DatePickerInterface } from '../../utils/constants/Interfaces.constants';
import enIN from 'date-fns/locale/en-IN';
registerLocale('en-IN', enIN)

const CustomDatepicker: React.FunctionComponent<DatePickerInterface> = ({
    startDate = new Date(),
    onChange,
    label = '',
    required = false,
    selectedDate = new Date(),
    calenderKey = '',
    minDate = new Date('01/01/2023'),
    maxDate = new Date('12/31/2030')
}) => {


  return (
    <div className="custom-datepicker">
        {
            label.length !== 0 &&
            <label data-required={required} htmlFor="date-picker" className='mb-1 d-block text-capitalize weight-400 text-primary-color'>{ label }</label>
        }
        <DatePicker 
            onChange={(date, event) => onChange(date, event, calenderKey)}
            startDate={startDate}
            locale='en-IN'
            required={required}
            selected={selectedDate}
            dateFormat={'dd/MM/yyyy'}
            className='text-primary-color'
            minDate={minDate}
            maxDate={maxDate}
        />
    </div>
  )
}

export default CustomDatepicker